import { Box, Drawer, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import NotificationContent from './NotificationContent';
import { useDispatch, useSelector } from 'react-redux';
import { setNotification } from '@redux/slices/homeSlice';

const Notification = () => {
    const dispatch = useDispatch()
    const { notification } = useSelector((state) => state?.home)
    const handleClose = () => {
        dispatch(setNotification(false))
    }
    return (
        <>
            <Drawer open={notification} onClose={handleClose}>
                <NotificationContent handleClose={handleClose} />
            </Drawer>

        </>
    )
}

export default Notification